import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import { ResponseDto } from '@diritto/common/base/response.dto';
import {
  RecentlyReadContentResponseDto,
  RecentlyReadContentsResponseDto,
} from '@diritto/common/recentlyRead/dtos/recently-read.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class RecentlyReadApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getContents(paginator?: BasePaginatorDto) {
    const res = await this.http.get<RecentlyReadContentsResponseDto>(`${this.url}/recently-read/contents`, {
      params: paginator,
    });
    return res.data;
  }

  async getContent(contentId: number) {
    const res = await this.http.get<RecentlyReadContentResponseDto>(`${this.url}/recently-read/contents/${contentId}`);
    return res.data;
  }

  async readEpisode(contentId: number, episodeId: number) {
    const res = await this.http.post(`${this.url}/recently-read/contents/${contentId}/episodes/${episodeId}`);
    return res.data;
  }

  async deleteItem(contentId: number) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/recently-read/contents/${contentId}`);
    return res.data;
  }

  async deleteItems(contentIds: number[]) {
    const res = await this.http.delete<ResponseDto>(`${this.url}/recently-read/contents/bulk`, {
      data: { contentIds },
    });
    return res.data;
  }
}
